import React from 'react';

import NewsletterFormContainer from 'dpl/containers/NewsletterFormContainer';

export default function NewsletterSignup() {
  return (
    <div className="PrismicHubNewsletterSignup container">
      <NewsletterFormContainer className="br2" />
    </div>
  );
}
